import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './index.css';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { getMatches, isValid } from 'driver-license-validator';

export default function PaymentDetails({ ...prop }) {
  const props = prop.props;
  const { id } = useParams();
  const navigate = useNavigate();

  // const [driverLicenceImg, setDriverLicenceImg] = useState();
  // const [name, setName] = useState(null);
  // const [email, setEmail] = useState(null);
  // const [mobileNo, setMobileNo] = useState(null);
  // const [flightNo, setFlightNo] = useState(null);
  // const [driverLicenseNo, setDriverLicenseNo] = useState(null);
  // const [airlineName, setAirlineName] = useState(null);
  // const [insurancePolicyNo, setInsurancePolicyNo] = useState(null);
  // const [insuranceExpDate, setInsuranceExpDate] = useState(null);

  const [verifyDriverLicenseNo, setVerifyDriverLicenseNo] = useState(null);
  // console.log(params);

  const handleDriverLicenseVerify = () => {
    // console.log(driverLicenseNo);
    setVerifyDriverLicenseNo(isValid(props.driverLicenseNo));
  };

  const handleSave = (e) => {
    e.preventDefault();
    // console.log({ props });

    const formData = new FormData();
    formData.append('File', props.driverLicenceImg);
    console.log(formData);

    navigate(`/payment/${id}`);
  };

  return (
    <div className='paymentDetails_wrapper'>
      <div className='paymentDetails'>
        <div className='paymentDetails_heading'>User Information</div>
        <form
          action='#'
          onSubmit={(e) => handleSave(e)}
          className='card_details'
        >
          <div className='info_wrapper'>
            <div className='info_row'>
              <TextField
                required
                className='info_input'
                id='outlined-basic'
                label='Enter Name'
                variant='outlined'
                value={props.name}
                onChange={(e) => props.setName(e.target.value)}
              />
              <TextField
                required
                type='email'
                className='info_input'
                id='outlined-basic'
                label='Enter Email'
                variant='outlined'
                value={props.email}
                onChange={(e) => props.setEmail(e.target.value)}
              />
            </div>
            <div className='info_row'>
              <TextField
                type='number'
                required
                className='info_input'
                id='outlined-basic'
                label='Enter Phone Number'
                variant='outlined'
                value={props.mobileNo}
                onChange={(e) => props.setMobileNo(e.target.value)}
              />
              <TextField
                type='text'
                required
                className='info_input'
                id='outlined-basic'
                label='Flight #'
                variant='outlined'
                value={props.flightNo}
                onChange={(e) => props.setFlightNo(e.target.value)}
              />
            </div>
            <div className='info_row '>
              <div className='driverLicenseNo'>
                <TextField
                  required
                  type='text'
                  className='info_input'
                  id='outlined-basic'
                  label='Driver License No.'
                  variant='outlined'
                  value={props.driverLicenseNo}
                  onChange={(e) => (
                    props.setDriverLicenseNo(e.target.value),
                    setVerifyDriverLicenseNo(null)
                  )}
                />
                <button
                  className={`driver_license_verify  ${
                    verifyDriverLicenseNo === false && 'not_verified'
                  }`}
                  disabled={props.driverLicenseNo === null ? true : false}
                  onClick={handleDriverLicenseVerify}
                >
                  {verifyDriverLicenseNo === null
                    ? 'Verify'
                    : verifyDriverLicenseNo
                    ? 'Verified'
                    : 'Not Verified'}
                </button>
              </div>
              <FormControl
                className='user_airline'
                sx={{ m: 1, minWidth: 120 }}
              >
                <InputLabel id='airport_name'>Enter Airline Name</InputLabel>
                <Select
                  className='airport_name'
                  labelId='airport_name'
                  id='demo-simple-select'
                  value={props.airlineName}
                  label='Enter Airline Name'
                  onChange={(e) => props.setAirlineName(e.target.value)}
                >
                  <MenuItem className='airport_name_menu_item' value={10}>
                    Qatar Airways
                  </MenuItem>
                  <MenuItem className='airport_name_menu_item' value={20}>
                    Singapore Airlines
                  </MenuItem>
                  <MenuItem className='airport_name_menu_item' value={30}>
                    Emirates
                  </MenuItem>
                  <MenuItem className='airport_name_menu_item' value={30}>
                    Japan Airlines
                  </MenuItem>
                  <MenuItem className='airport_name_menu_item' value={30}>
                    EVA Air
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className='info_row '>
              <Button
                required
                className='user_upload_btn'
                variant='contained'
                component='label'
              >
                <svg
                  width='36'
                  height='36'
                  viewBox='0 0 36 36'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M1.125 22.275C1.42337 22.275 1.70952 22.3935 1.9205 22.6045C2.13147 22.8155 2.25 23.1016 2.25 23.4V29.025C2.25 29.6217 2.48705 30.194 2.90901 30.616C3.33097 31.0379 3.90326 31.275 4.5 31.275H31.5C32.0967 31.275 32.669 31.0379 33.091 30.616C33.5129 30.194 33.75 29.6217 33.75 29.025V23.4C33.75 23.1016 33.8685 22.8155 34.0795 22.6045C34.2905 22.3935 34.5766 22.275 34.875 22.275C35.1734 22.275 35.4595 22.3935 35.6705 22.6045C35.8815 22.8155 36 23.1016 36 23.4V29.025C36 30.2185 35.5259 31.3631 34.682 32.207C33.8381 33.0509 32.6935 33.525 31.5 33.525H4.5C3.30653 33.525 2.16193 33.0509 1.31802 32.207C0.474106 31.3631 0 30.2185 0 29.025V23.4C0 23.1016 0.118526 22.8155 0.329505 22.6045C0.540483 22.3935 0.826631 22.275 1.125 22.275Z'
                    fill='white'
                  />
                  <path
                    d='M17.2039 2.5785C17.3084 2.47373 17.4326 2.39061 17.5693 2.33389C17.7059 2.27718 17.8525 2.24799 18.0004 2.24799C18.1484 2.24799 18.2949 2.27718 18.4316 2.33389C18.5683 2.39061 18.6924 2.47373 18.7969 2.5785L25.5469 9.3285C25.7582 9.53974 25.8769 9.82625 25.8769 10.125C25.8769 10.4237 25.7582 10.7103 25.5469 10.9215C25.3357 11.1327 25.0492 11.2514 24.7504 11.2514C24.4517 11.2514 24.1652 11.1327 23.9539 10.9215L19.1254 6.09075V25.875C19.1254 26.1734 19.0069 26.4595 18.7959 26.6705C18.585 26.8815 18.2988 27 18.0004 27C17.7021 27 17.4159 26.8815 17.205 26.6705C16.994 26.4595 16.8754 26.1734 16.8754 25.875V6.09075L12.0469 10.9215C11.9423 11.0261 11.8182 11.1091 11.6815 11.1657C11.5448 11.2223 11.3984 11.2514 11.2504 11.2514C11.1025 11.2514 10.956 11.2223 10.8194 11.1657C10.6827 11.1091 10.5585 11.0261 10.4539 10.9215C10.3493 10.8169 10.2664 10.6927 10.2098 10.5561C10.1532 10.4194 10.124 10.2729 10.124 10.125C10.124 9.97707 10.1532 9.8306 10.2098 9.69393C10.2664 9.55727 10.3493 9.4331 10.4539 9.3285L17.2039 2.5785Z'
                    fill='white'
                  />
                </svg>
                {props.driverLicenceImg
                  ? props.driverLicenceImg.name
                  : 'Upload Attachments (Driver License)'}
                <input
                  required
                  type='file'
                  name='UserDriverLicense'
                  id='UserDriverLicense'
                  hidden
                  onChange={(e) => props.setDriverLicenceImg(e.target.files[0])}
                />
              </Button>
            </div>
            <div className='info_row '>
              <TextField
                required
                type='text'
                className='info_input'
                id='outlined-basic'
                label='Insurance  Policy'
                variant='outlined'
                value={props.insurancePolicyNo}
                onChange={(e) => props.setInsurancePolicyNo(e.target.value)}
              />
              <div className='date_time'>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    // shouldDisableDate={(23, 24, 25) => true}
                    disablePast
                    label='Insurance  Expiry Date'
                    value={props.insuranceExpDate}
                    onChange={(newValue) => {
                      props.setInsuranceExpDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        required
                        type='date'
                        className='time_date_picker'
                        size=''
                        {...params}
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </div>
          </div>
          <div className='confirmation_btn'>
            <button
              type='submit'
              disabled={verifyDriverLicenseNo ? false : true}
            >
              {' '}
              Save{' '}
            </button>
          </div>
        </form>
      </div>
      <div className='paymentDetails_card'>
        {/* <img src='/assets/imgs/bg_car.png' alt='credit_card' /> */}
      </div>
    </div>
  );
}
